import Document, { ErrorDocument } from 'requests/objects/document'
// eslint-disable-next-line import/no-cycle, import/named
import ApiHandler from 'requests/apiHandler'

/**
 * DocumentsHandler
 * @augments {ApiHandler<Document, ErrorDocument>}
 */
export default class DocumentsHandler extends ApiHandler {
    constructor() {
        super({ type: Document, errorType: ErrorDocument, key: 'documents' })
    }

    getAllFromPage(params = {}, currentPage = 1, recordsPerPage = 20) {
        const request = this.initFetchRequest({
            params: {
                ...params,
                currentPage,
                recordsPerPage,
            },
        })

        return this.getRequestApi(
            () => request.fetchRequest
                .then(res => res.data)
                .then(({ documents, totalRecords, totalPages }) => {
                    const items = (documents ?? []).map(o => new Document(o))
                    return { items, totalRecords, totalPages }
                })
                .catch(err => { throw this.handleError(err) }),
            request.cancelToken,
        )
    }
}
